import { render, staticRenderFns } from "./registrationAddition.vue?vue&type=template&id=d92238c4&scoped=true&"
import script from "./registrationAddition.vue?vue&type=script&lang=js&"
export * from "./registrationAddition.vue?vue&type=script&lang=js&"
import style0 from "./registrationAddition.vue?vue&type=style&index=0&id=d92238c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92238c4",
  null
  
)

export default component.exports